<h1>text properties</h1>
toggle to change the value; when unchecked = value will be the default of the clients<br />

<form [formGroup]="form" (ngSubmit)="submit()">
  @for (property of properties; track property) {
    <div>
      <label> <input type="checkbox" [formControlName]="property" /> {{ property }} </label>
      @if (form.get(property)?.value) {
        <div>
          <!-- eslint-disable-next-line @angular-eslint/template/prefer-template-literal -->
          <input type="text" [formControlName]="property + '-value'" />
        </div>
      }
    </div>
  }
  <button type="submit">Save</button>
</form>
